import * as classNames from 'classnames';
import * as queryString from 'query-string';
import trim = require('lodash/trim');
import {detect} from 'detect-browser';
import {IPlace} from '../redux/modules/search-places-module/reducer';
import {IUserAddress} from '../redux/modules/scheduler/reducer';
import {
    UNSUPPORTED_IOS_BROWSER,
    UNSUPPORTED_MOBILE,
    UNSUPPORTED_MOBILE_BROWSER,
    UNSUPPORTED_WEBRTC,
} from '../data';

const browser = detect();
const mobileOs = ['ios', 'android os', 'blackBerry os', 'windows mobile'];
export const isMobile = (): boolean => (
  browser && (mobileOs.indexOf(browser.os.toLowerCase()) >= 0)
);

export const isIos = (): boolean => (
    browser && browser.os.toLowerCase() === 'ios'
);

export const webRtcDisabled = (): boolean => {
  const agent: any = navigator;
  return !(agent.getUserMedia || agent.webkitGetUserMedia || agent.mozGetUserMedia || (agent.mediaDevices && agent.mediaDevices.getUserMedia));
};

export const webSocketDisabled = (): boolean => {
  return !(window as any).WebSocket || !(window as any).WebSocket.name;
};

export const isAudioVideoUnsupported = (): boolean => {
  return webSocketDisabled() || webRtcDisabled();
};

export const normalizeConsoleOutput = (message: string) => (
  message.split('\n').filter(m => m.trim() !== '')
);

export const redirectTo = (url: string): void => {
  window.location.href = url;
};

export const getRequestId = (): string => {
  const parsedSearch = queryString.parse(location.search);
  const requestIdFromSearch = parsedSearch.requestId;
  const requestIdFromUrl = trim(location.pathname.replace('session/join', ''), '/');

  return requestIdFromSearch || requestIdFromUrl || '';
};

export const defaultClasses = (prefix: string, modifier: string, className?: string): string => classNames(
  prefix,
  {[`${prefix}_${modifier}`]: modifier},
  {[`${prefix}_${className}`]: className},
);

export function convertPlaceToUserAddress(place: IPlace): IUserAddress {
  if (!place) {
    return null;
  }

  let city: string;
  let country: string;
  let state: string;

  city = place.terms[0].value;

  if (place.terms.length === 2) {
    country = place.terms[1].value;
  } else if (place.terms.length === 3) {
    state = place.terms[1].value;
    country = place.terms[2].value;
  }

  return {
    id: place.id,
    autocomplete: place.description,
    city,
    country,
    state,
  };
}

export const unsupportedMessage = (isMobileSupported?: boolean): string => {
    if (isMobile()) {
        if (isMobileSupported) {
            if (isIos()) {
                return UNSUPPORTED_IOS_BROWSER;
            }
            return UNSUPPORTED_MOBILE_BROWSER;
        }
        return UNSUPPORTED_MOBILE;
    }
    if (webRtcDisabled() || webSocketDisabled()) {
        return UNSUPPORTED_WEBRTC;
    }

    return '';
};
